// store.js
import { configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authReducer from "./authSlice";
import selectedCompanyReducer from "./selectedCompanySlice";
import themeReducer from "./themeSlice";

const rootPersistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth","selectedCompany", "theme"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  selectedCompany: selectedCompanyReducer,
  theme: themeReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
